import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';

export const StyledBtnDropdown = styled('div')`
  margin-right: 8px;
  .dropdow-button {
    border: 1px solid #1e164e29;
    width: max-content;
    display: flex;
    align-items: center;
    padding: 10px 16px;
    border-radius: 480px;
    box-sizing: border-box;
    height: 44px;
  }
  .button-content {
    font-weight: 500;
    font-size: 14px;
    color: #1e164e;
    text-transform: none;
  }
  .button-wrapper {
    display: flex;
    align-items: center;
    .awesome-button {
      margin-right: 2px;
    }
  }
  .content-loading {
    height: 40px;
    box-sizing: border-box;
    padding: 8px 12px;
    box-shadow: 0px 2px 24px 0px #007aff7a;
    background: linear-gradient(90.91deg, #007aff -2.83%, #ffffff 143.04%);
  }
`;

export const StyledLoading = styled('div')`
  .content-loading {
    box-sizing: border-box;
    padding: 8px 12px;
    box-shadow: 0px 2px 24px 0px #007aff7a;
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 480px;
    .text-loading {
      background: linear-gradient(90.91deg, #007aff -2.83%, #ffffff 143.04%);
      margin-left: 10px;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
`;

export const TooltipWrapper = styled('div')`
  position: relative;
  display: inline-block;
`;

export const StyledHightLightWord = styled('div')`
  .spelling {
    background-color: rgba(255, 59, 48, 0.08);
    border-bottom: 1px solid rgba(255, 59, 48, 1);
    cursor: pointer;
    position: relative;
  }
  .suggest {
    background-color: rgba(0, 122, 255, 0.08);
    border-bottom: 1px dotted rgba(0, 122, 255, 1);
    cursor: pointer;
    position: relative;
  }
  .grammar {
    background-color: rgba(88, 86, 214, 0.16);
    border-bottom: 1px dotted rgba(88, 86, 214, 1);
    cursor: pointer;
    position: relative;
  }
`;
export const StyledPopupEditWord = styled('div')`
  .head {
    display: flex;
    justify-content: space-between;
    width: 288px;
    align-self: center;
  }
  .icon-morevert {
    color: ${COLOR.darkBlue};
  }
  .title {
    color: rgba(0, 0, 0, 1);
    font-size: 14px;
    margin-right: 8px;
    font-weight: 500;
  }
  .flex-item {
    display: flex;
    align-items: center;
  }
  .content {
    margin-top: 4px;
    display: flex;
    flex-direction: column;
    .word {
      font-size: 14px;
      color: #1c1c1e;
      margin-bottom: 4px;
    }
    input {
      outline: none;
      border: none;
      padding: 8px 12px;
      border: 1px solid #1e164e29;
      font-size: 14px;
      height: 40px;
      box-sizing: border-box;
      border-radius: 8px;
      font-family: 'SF Pro', sans-serif;
    }
  }
  .actions {
    margin-top: 16px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 40px;
    .btn-action {
      text-transform: none;
      color: rgba(30, 22, 78, 1);
      font-size: 14px;
      font-weight: 500;
      width: 116px;
      margin-right: 8px;
      border-radius: 8px;
      height: 40px;
    }
    .outline {
      border: 1px solid #1e164e52;
    }
  }
`;

export const CountWordStyled = styled('div')`
  height: 40px;
  display: flex;
  align-items: center;
  .text {
    color: rgba(255, 59, 48, 1);
    font-size: 12px;
    font-weight: 700;
    background-color: rgba(255, 59, 48, 0.08);
    padding: 4px 12px;
    border-radius: 100px;
  }
`;
